import { render } from "./NewLoyerList.vue?vue&type=template&id=953ec4d4"
import script from "./NewLoyerList.vue?vue&type=script&lang=js"
export * from "./NewLoyerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__